<template>
  <el-dialog
    :title="dialogInfo.title"
    :visible.sync="dialogInfo.show"
    v-if="dialogInfo.show"
    width="550px"
  >
    <el-form
      ref="curdForm"
      size="small"
      label-position="right"
      label-width="100px"
    >
      <el-form-item>
        <butn btntype="primary" title="下载模板" @click="downlodTemplate"></butn>
      </el-form-item>
      <el-form-item
        required
        label="附件："
        error="请上传附件"
        :show-message="file == null"
      >
        <upload v-model="file" ref="removeFile" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeDia" title="取消"></butn>
      <butn btntype="primary" @click.native="sureImport" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Upload from "@/components/upload/excel";
import { downloadByUrl } from "../../../utils/common";

export default {
  components: { butn, Upload },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {},
    },
    classId: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      file: null,
    };
  },
  methods: {
    closeDia() {
      this.$emit("close", false);
    },
    sureImport() {
      if (this.file != null) {
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("classId", this.classId);
        let api = this.dialogInfo.api;
        api(formData).then((res) => {
          if (res && res.code == 0) {
            if (res.data != null) {
              this.$message.error("导入包含错误数据，请检查");
              this.closeDia();
              this.$router.push({
                path: "/excelError",
              });
              localStorage.setItem("errorExcelData", JSON.stringify(res.data));
            } else {
              this.$message.success(res.msg);
              this.$emit("close", true);
            }
          } else {
            this.$refs.removeFile.$refs.upload.uploadFiles.pop();
            this.file = null;
          }
        });
      }
    },
    downlodTemplate() {
      downloadByUrl(null, this.dialogInfo.templateUrl)
    }
  },
};
</script>

<style>
</style>